import { addRemoveCouponsListener } from './coupon.js';
import { createAutoComplete } from './autocomplete.js';
import { initializeAriaCurrent } from './header-aria-current.js';
import { initializeExpandable } from './expandable.js';
import { addDefaultDialogPopupListeners } from '../popup';
import { attachAddressAutocomplete } from './address-autocomplete.js';

function renderImageWithSizesLocal(imageUrl, alt = '', width = 50, height = 50) {
  const url = imageUrl + '?w=' + width + '&h=' + height + '&aspect=letterbox';
  return '<img src="' + url + '" width="' + width + '" height="' + height + '" alt="' + alt + '">';
}

/**
 * Initializes expandable elements in selected containers.
 */
function initializeExpandables() {
  document.querySelectorAll('.js_faq_container').forEach((container) => {
    initializeExpandable(container);
  });
  document.querySelectorAll('#inhaltsverzeichnis').forEach((container) => {
    initializeExpandable(container);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  addRemoveCouponsListener();
  attachAddressAutocomplete();

  // Initialize header search autocompletes (buy/sell).
  createAutoComplete(
    '.js_input_auto_buy',
    '/findTypes.php',
    function (suggestion) {
      window.location.href = suggestion.product_page_url;
    },
    function (sugg) {
      return (
        renderImageWithSizesLocal(sugg.image_url) +
        '<span>' +
        sugg.article_type_name +
        (sugg.is_on_stock ? '<br><span class="green_text">auf Lager</span>' : '') +
        '</span>' +
        '<div class="clear_both"></div>'
      );
    },
  );

  createAutoComplete(
    '.js_input_auto_sell',
    '/findTypes.php?is_ankauf=1',
    function (suggestion) {
      window.location.href = suggestion.buying_page_url;
    },
    function (sugg) {
      return (
        renderImageWithSizesLocal(sugg.image_url) +
        '<span>' +
        sugg.article_type_name +
        '</span>' +
        '<div class="clear_both"></div>'
      );
    },
  );

  initializeAriaCurrent();
  initializeExpandables();
  addDefaultDialogPopupListeners();
});
